import axios from 'axios';
import { store } from '../store/store';
import { logout } from '../store/slices/authSlice';
import { showNotification } from '../store/slices/notificationSlice';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Function to set auth token in headers
export const setAuthHeader = (token: string | null) => {
  if (token) {
    apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete apiClient.defaults.headers.common['Authorization'];
  }
};

// Response interceptor to handle 401 errors globally
apiClient.interceptors.response.use(
  response => response, // Return successful responses as-is
  error => {
    // Handle 401 Unauthorized errors
    if (error.response && (error.response.status === 401 || error.response.status === 502)) {
      // Dispatch notification to show error popup
      store.dispatch(
        showNotification({
          message: 'Your session has expired or you are not authorized. Please log in again.',
          type: 'error',
          duration: 6000,
        }),
      );

      // Logout the user to clear any stored tokens and auth state
      store.dispatch(logout());

      // Redirect to /login page
      window.location.href = '/login';

      // Don't retry the request - reject the promise with the error
      return Promise.reject(error);
    }

    // For other errors, just pass them through to be handled by the caller
    return Promise.reject(error);
  },
);

export default apiClient;
